var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9476 16.6743L4.24346 9.54307C3.91885 9.24288 3.91885 8.7579 4.24346 8.45693L11.9476 1.32572C12.4162 0.891426 13.1786 0.891426 13.6481 1.32572C14.1167 1.76002 14.1167 2.46488 13.6481 2.89917L7.05761 9.00039L13.6481 15.1C14.1167 15.5351 14.1167 16.24 13.6481 16.6743C13.1786 17.1086 12.4162 17.1086 11.9476 16.6743Z",
    fill: "#2D49FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.c6202cda.svg";
export { ForwardRef as ReactComponent };